module.exports = __webpack_public_path__ + "img/rss.9e0b66d1.svg";